import React from 'react'
import { NavDropdown, NavLinkItem, NavWhatsApp } from './NavDropdown'

const hub = (slug) => `/sg/aircon-servicing-singapore/${slug}`

const AIRCON_SERVICES = [
    ['cleaning-maintenance-service', 'AC General Service'],
    ['aircon-chemical-wash-and-overhaul', 'Chemical Wash & Overhaul'],
    ['aircon-repair', 'Aircon Repair'],
    ['urgent-aircon-servicing', 'Urgent Servicing & Repair'],
    ['aircon-condenser-cleaning', 'Compressor Cleaning'],
    ['aircon-gas-top-up', 'Gas Top Up'],
    ['aircon-installation', 'AC Installation'],
    ['aircon-parts-replacement', 'Parts Replacement'],
    ['annual-package', 'Annual Package Service'],
    ['ceiling-cassette-aircon-service', 'Cassette Aircon Servicing'],
].map(([slug, label]) => ({ href: hub(slug), label }))

const AIRCON_PROBLEMS = [
    ['aircon-leaking-water', 'Water Leaking'],
    ['aircon-not-cooling', 'Insufficient Cooling'],
    ['do-this-when-your-aircon-stops-working-suddenly', 'Aircon Won’t Turn On'],
    ['aircon-overheating', 'Aircon Overheating'],
    ['aircon-gas-leakage', 'Gas Leakage'],
].map(([slug, label]) => ({ href: hub(slug), label }))

const AIRCON_BRANDS = [
    ['daikin', 'Daikin'],
    ['lg-air-conditioner', 'LG'],
    ['mitsubishi-electric', 'Mitsubishi'],
    ['panasonic', 'Panasonic'],
    ['professional-prism-aircon-servicing-in-singapore', 'Prism+'],
    ['samsung', 'Samsung'],
].map(([slug, label]) => ({ href: hub(slug), label }))

// Desktop nav extras for the aircon section.
export const AirconNavBar = () => (
    <>
        <NavDropdown label="Aircon Services" items={AIRCON_SERVICES} />
        <NavLinkItem href={hub('aircon-servicing-price-singapore')} label="Pricing" ariaLabel="Aircon Servicing Pricing Page" />
        <NavDropdown label="Aircon Problems" items={AIRCON_PROBLEMS} />
        <NavDropdown label="Air-Con Brands" items={AIRCON_BRANDS} />
        <NavLinkItem href="/sg/blogs/hvac-services" label="Blogs" ariaLabel="Aircon Services Blogs" />
        <NavWhatsApp text="Hi, I'd like to book aircon servicing." ariaLabel="WhatsApp StringsSG to book aircon servicing" />
    </>
)
